export const faqItems = [
  {
    question: "Qual a validade dos produtos?",
    answer: "Os sanduíches naturais possuem validade de 10 dias quando armazenados corretamente refrigerados. Os mini pastéis e demais congelados possuem prazo de validade conforme indicação em cada embalagem. Recomendamos sempre verificar a data de validade no momento da compra.",
  },
  {
    question: "Vocês trabalham com atacado?",
    answer: "Sim! A Big Mania atua tanto no atacado quanto no varejo. Oferecemos preços especiais para compras em grande quantidade, supermercados, mercadinhos, escolas, empresas e revendedores. Entre em contato para solicitar uma tabela de preços atacado.",
  },
  {
    question: "Existe pedido minimo?",
    answer: "Para varejo, não há pedido mínimo. Para atacado e empresas, trabalhamos com quantidades mínimas que variam conforme o produto. Entre em contato pelo WhatsApp para saber os valores específicos.",
  },
  {
    question: "Como funciona a entrega?",
    answer: "As entregas são realizadas através de rotas programadas devido ao grande volume de pedidos. Não é possível garantir horário exato, mas sempre respeitamos a janela de entrega combinada. Entregas gratuitas disponíveis para pedidos no atacado. Horário: Segunda a sexta, 07h às 17h.",
  },
  {
    question: "Os produtos são congelados?",
    answer: "Os sanduíches naturais são produtos frescos e devem ser mantidos refrigerados. Os mini pastéis e outros itens da linha congelada são entregues congelados e devem ser armazenados no freezer até o momento do preparo.",
  },
  {
    question: "Como armazenar corretamente?",
    answer: "Os sanduíches naturais devem ser armazenados em refrigeração entre 2°C e 8°C. Os produtos congelados devem permanecer no freezer a -18°C. Nunca deixe os produtos expostos ao sol ou em temperatura ambiente por longos períodos.",
  },
  {
    question: "Atendem eventos corporativos?",
    answer: "Sim! Somos especialistas em alimentação para eventos corporativos e particulares. Oferecemos coffee breaks, lanches para reuniões, treinamentos, congressos, workshops, confraternizações e eventos institucionais. Cardápios personalizados disponíveis.",
  },
  {
    question: "Posso montar um cardápio personalizado?",
    answer: "Com certeza! Para eventos e empresas, montamos cardápios personalizados de acordo com suas necessidades, orçamento e preferências. Entre em contato com pelo menos 5 dias úteis de antecedência para que possamos planejar tudo com perfeição.",
  },
  {
    question: "Qual o prazo para solicitar um evento?",
    answer: "Recomendamos solicitar o orçamento com pelo menos 5 dias úteis de antecedência para eventos menores e 10 dias para eventos de grande porte. Assim garantimos disponibilidade e organização impecável.",
  },
  {
    question: "Entregam em toda Fortaleza?",
    answer: "Sim, realizamos entregas em toda Fortaleza e região metropolitana. As rotas são organizadas por região para garantir eficiência e pontualidade. Consulte-nos sobre sua localização específica.",
  },
  {
    question: "Como solicitar um orçamento?",
    answer: "Você pode solicitar um orçamento pelo WhatsApp (85) 3494-2701, por telefone ou preenchendo o formulário de contato em nosso site. Responderemos em até 24 horas úteis com uma proposta personalizada.",
  },
];